import React from "react"

import { TextInput, TextInputProps } from "./TextInput"

export function EmailInput(props: TextInputProps) {
  return <TextInput {...props} keyboardType="email-address" />
}
